<template>
  <div :id="$style.side_menu_bar">
    <ul>
      <li v-for="item in items" :key="item.id" @click="childFunction(item)">{{ item }}</li>
    </ul>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  name: "SideMenuBar",
  props: {
    items: {
      type: Array
    }
  },
  methods: {
    childFunction(item) {
      this.$emit("child_event", item);
    }
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  #side_menu_bar {
    ul {
      padding: 0;
      li {
        list-style: none;
        width: 150px;
        padding: 3px 0px;
        margin: 1px 0px;
        border-bottom: 1px solid #3b3b3b;
        color: #3b3b3b;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  #side_menu_bar {
    ul {
      padding: 0;
      li {
        list-style: none;
        width: 150px;
        padding: 3px 0px;
        margin: 1px 0px;
        border-bottom: 1px solid #3b3b3b;
        color: #3b3b3b;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
</style>
